import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from '../lib/toast';

// A single, honest reminder when a trial is about to end. No countdown pressure.
export default function TrialBanner() {
  const { license, isMember } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!isMember || license.status !== 'trial' || license.daysLeft > 3) return;
    const key = `pa_trial_notice_${new Date().toDateString()}`;
    try {
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    } catch (e) { /* storage unavailable */ }
    toast(`Your free trial ends in ${license.daysLeft} day${license.daysLeft === 1 ? '' : 's'}`, {
      description: 'Nothing is charged automatically. Subscribe if you’d like to keep access.',
      action: { label: 'See plans', onClick: () => navigate('/pricing') },
      duration: 10000,
    });
  }, [isMember, license, navigate]);
  return null;
}
